// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu--1SZt8 ul{list-style:none;margin:0;padding:0}.menu--1SZt8>ul{border-bottom:1px solid #d9d9d9}.menu--1SZt8>ul>li{border-top:1px solid #d9d9d9}\n", ""]);
// Exports
exports.locals = {
	"menu": "menu--1SZt8"
};
module.exports = exports;
